import styled, { createGlobalStyle } from 'styled-components';
import { Image } from "../../styles/image";
import {customScrollBarStyle, getKeyframes} from "../../utils/getKeyframes";
import {
  cardBackground,
  borderColor,
  borderRadius,
  cardShadow,
  cardShadowLg,
  media,
} from "../../utils/variables";
import {CloseOutlined, MinusOutlined} from "@ant-design/icons";

interface ModalProps {
    hasContext?: boolean;
    mobile?: boolean;
    fullScreen?: boolean;
    isMacOS?: boolean;
    fitContent?: boolean;
    large?: boolean;
    noBackdrop?: boolean;
    stackIndex?: number;
}

export const ModalContainer = styled.div<ModalProps>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--modal-backdrop);
    backdrop-filter: blur(var(--modal-backdrop-blur)) brightness(var(--modal-backdrop-brightness));
    -webkit-backdrop-filter: blur(var(--modal-backdrop-blur)) brightness(var(--modal-backdrop-brightness));
    animation: fadeIn 250ms forwards;
    z-index: ${({stackIndex = 0}) => 10 + stackIndex};

    ${media.mobile} {
        align-items: ${({fitContent}) => fitContent ? 'center' : 'flex-start'};
        background-color: var(--modal-backdrop);
    }

    ${media.tablet} {
        align-items: ${({fitContent}) => fitContent ? 'center' : 'flex-start'};
        background-color: var(--modal-backdrop);
    }
  
    ${getKeyframes('fadeIn')}
`;

export const ModalInner = styled.div<ModalProps>`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: ${borderRadius};
    background-color: ${cardBackground};
    box-shadow: ${cardShadowLg};
    border: 1px solid ${borderColor};
    //  max-width: 500px;
    width: 100%;
    animation: scaleIn 250ms forwards;
    min-width: 500px;

    max-width: ${({fullScreen, fitContent, large}) => {
        return fullScreen ? `95vw` : fitContent ? 'fit-content' : large ? `1000px` : '500px'
    }};
    max-height: ${({fullScreen}) => {
        return fullScreen ? `95vh` : `unset`
    }};
    height: ${({fullScreen}) => {
        return fullScreen ? `95vh` : `unset`
    }};

    ${({hasContext}) => {
        return hasContext
                ? ''
                : 'animation: scaleIn 250ms forwards'
    }};

    ${getKeyframes('scaleIn')}
    ${media.mobile} {
        height: ${({fitContent}) => fitContent ? 'auto' : '100dvh'};
        min-width: 100vw;
        width: 100vw;
        max-width: 100vw;
        max-height: ${({fitContent}) => fitContent ? '100dvh' : '100dvh'};
        border-radius: 0;
        margin: 0;
        padding: 0;
    }

    ${media.tablet} {
        min-width: 100vw;
        height: ${({fitContent}) => fitContent ? 'auto' : '100dvh'};
        width: 100vw;
        max-width: 100vw;
        max-height: ${({fitContent}) => fitContent ? '100dvh' : '100dvh'};
        border-radius: 0;
        margin: 0;
        padding: 0;
    }
`;

export const AccountsModalInner = styled.div<ModalProps>`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: ${borderRadius};
    background-color: ${cardBackground};
    box-shadow: ${cardShadowLg};
    border: 1px solid ${borderColor};
    width: 100%;
    max-width: ${({fullScreen, fitContent}) => {
        return fullScreen ? `95vw` : fitContent ? 'fit-content' : `1000px`
    }};
    max-height: ${({fullScreen}) => {
        return fullScreen ? `95vh` : `unset`
    }};
    height: ${({fullScreen}) => {
        return fullScreen ? `95vh` : `unset`
    }};

    ${({hasContext}) => {
        return hasContext
                ? ''
                : 'animation: scaleIn 250ms forwards'
    }};

    ${media.mobile} {
        height: ${({fitContent}) => fitContent ? 'auto' : '100dvh'};
        min-width: 100vw;
        width: 100vw;
        max-width: 100vw;
        max-height: ${({fitContent}) => fitContent ? '100dvh' : '100dvh'};
        border-radius: 0;
        margin: 0;
        padding: 0;
    }

    ${media.tablet} {
        min-width: 100vw;
        height: ${({fitContent}) => fitContent ? 'auto' : '100dvh'};
        width: 100vw;
        max-width: 100vw;
        max-height: ${({fitContent}) => fitContent ? '100dvh' : '100dvh'};
        border-radius: 0;
        margin: 0;
        padding: 0;
    }
`;

export const TransProdsModalInner = styled.div`
    border-radius: ${borderRadius};
    background-color: ${cardBackground};
    box-shadow: ${cardShadowLg};
    border: 1px solid ${borderColor};
    max-width: 860px;
    width: 100%;
    animation: scaleIn 250ms forwards;
    ${getKeyframes('scaleIn')}

    ${media.mobile} {
        height: 100dvh;
        min-width: 100vw;
        width: 100vw;
        max-width: 100vw;
        border-radius: 0;
        margin: 0;
        padding: 0;
    }

    ${media.tablet} {
        min-width: 100vw;
        height: 100dvh;
        width: 100vw;
        max-width: 100vw;
        border-radius: 0;
        margin: 0;
        padding: 0;
    }
`;

export const ModalHeader = styled.div`
    width: 100%;
    border-bottom: 1px solid ${borderColor};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 22px;
    
    ${Image} {
        opacity: .4;
        transition: 250ms;
        cursor: pointer;
        :hover {
            opacity: .8;
            
        }
    }

    ${media.mobile} {
        padding: 12px 15px;
        position: sticky;
        top: 0;
        background: ${cardBackground};
        z-index: 1;
    }

    ${media.tablet} {
        padding: 12px 15px;
        position: sticky;
        top: 0;
        background: ${cardBackground};
        z-index: 1;
    }
`;

export const ModalBody = styled.div<{
    fullScreen?: boolean;
    fullScreenScrollable?: boolean;
    isMacOS?: boolean;
    fitContent?: boolean;
    large?: boolean;
}>`
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 22px;
    overflow-y: auto;
    max-height: ${({fullScreen, fitContent, large}) => {
        if (fullScreen) return `90vh`;
        if (fitContent) return `90vh`;
        if (large) return `90vh`;
        return `75vh`;
    }};

    ${({fullScreen, fullScreenScrollable}) => fullScreen && !fullScreenScrollable && `
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding: 0;
        flex: 1;
        height: 100%;
        max-height: none;
        min-height: 0;
    `}

    ${({fullScreen, fullScreenScrollable}) => fullScreen && fullScreenScrollable && `
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        padding: 22px;
        min-height: 0;
        height: auto;
        max-height: calc(95vh - 56px);
    `}

    ${({isMacOS}) => customScrollBarStyle(isMacOS!)}
    
    ${media.mobile} {
        padding: ${({fitContent, fullScreen, fullScreenScrollable}) =>
            fullScreen && fullScreenScrollable
                ? '0 15px 20px 15px'
                : fitContent ? '0 15px' : '0 15px 20px 15px'};
        background: ${cardBackground};
        border: none;
        max-height: ${({fitContent}) => fitContent ? 'calc(100dvh - 60px)' : 'calc(100dvh - 60px)'};
        height: ${({fitContent}) => fitContent ? 'calc(100dvh - 60px)' : 'calc(100dvh - 60px)'};
        overflow-y: ${({fullScreen, fullScreenScrollable}) =>
            fullScreen && !fullScreenScrollable ? 'hidden' : 'auto'};
        display: flex;
        flex-direction: column;
    }

    ${media.tablet} {
        padding: ${({fitContent, fullScreen, fullScreenScrollable}) =>
            fullScreen && fullScreenScrollable
                ? '0 15px 20px 15px'
                : fitContent ? '0 15px' : '0 15px 20px 15px'};
        background: ${cardBackground};
        border: none;
        max-height: ${({fitContent}) => fitContent ? 'calc(100dvh - 60px)' : 'calc(100dvh - 60px)'};
        height: ${({fitContent}) => fitContent ? 'calc(100dvh - 60px)' : 'calc(100dvh - 60px)'};
        overflow-y: ${({fullScreen, fullScreenScrollable}) =>
            fullScreen && !fullScreenScrollable ? 'hidden' : 'auto'};
        display: flex;
        flex-direction: column;
    }
`;

export const Error = styled.span`
    position: relative;
    left: -22px;
    width: calc(100% + 44px);
    padding: 10px 18px;
    background-color: var(--destructive);
    color: var(--primary-foreground);
    text-align: center;
`;

export const ModalGlobalStyles: any = createGlobalStyle`
  /* Блокировка скролла теперь управляется через bodyScrollLock утилиту */
`;

export const MinimizeIcon = styled(MinusOutlined)`
    height: 30px;
    width: 30px;
    opacity: 0.4;
    transition: 250ms;
    padding: 5px;
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
`

export const CloseIcon = styled(CloseOutlined)`
    height: 30px;
    width: 30px;
    opacity: 0.4;
    transition: 250ms;
    padding: 5px;
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
`
